import { loadConfig } from '@api/api';
import axios, { AxiosResponse } from 'axios';

export interface iEF {
  series_id: string;
  json: object;
}
const getEFApi = async (series_id: string) => {
  const BASE_URL = await loadConfig();
  return `${BASE_URL}/api/v1/series/ejection/${series_id}`;
};

async function ToFormData(info: iEF) {
  const formData = new FormData();
  const json_input = JSON.stringify(info.json);

  const blob = new Blob([json_input], { type: 'application/json' });
  formData.append('file', blob, 'ejection_fraction.json');
  return formData;
}

export async function send_ef_info(accessToken: string, info: iEF) {
  const url = await getEFApi(info.series_id);

  const send_info = await ToFormData(info);
  const res: AxiosResponse = await axios({
    method: 'post',
    url: url,
    headers: {
      Accept: '*/*',
      Authorization: `Bearer ${accessToken}`,
    },
    data: send_info,
  })
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });
  console.log(res);

  if (res.status == 201) {
    const ef_result_value = res.data['data']['EjectionFraction']['data'];
    const ef_result_file = res.data['data']['EjectionFraction']['Info'];
    return [true, ef_result_value, ef_result_file];
  }
  return [false, undefined, undefined];
}
async function make_dummy_json(info: string[][]) {
  return {
    SERIES: info,
  };
}
export async function example_send_ef_info(
  accessToken: string,
  series_id: string,
  info: string[][],
) {
  const json_info = await make_dummy_json(info);
  const [operation_result, ef_result] = await send_ef_info(accessToken, {
    series_id: series_id,
    json: json_info,
  });

  console.log('run status: ', operation_result);
  console.log('ef result: ', ef_result);
}
